import { Button } from '@material-ui/core'
import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'
import moment from 'moment'
import axios from 'axios'
import Toggle from 'react-toggle'
import ImageCropper from '../../../common/ImageCropper/ImageCropper'

class PackageAddEdit extends React.Component {
  state = {
    name_en: '',
    name_ar: '',
    desc_en: '',
    desc_ar: '',
    ref_name: '',

    start_day: '',
    end_day: '',

    is_special_package: false,

    start_date: null,
    end_date: null,

    package_start_date: moment().format('YYYY-MM-DD'),
    package_end_date: moment().add(1, 'M').format('YYYY-MM-DD'),

    is_active: true,

    isSaving: false,

    img: '',
  }

  handleChange = (event) => {
    let [name, value] = [event.target.name, event.target.value]

    this.setState(
      {
        [name]: value,
      },
      () => {
        if (name == 'start_date') {
          this.setState({
            start_day: moment(this.state.start_date).format('dddd').toLowerCase(),
          })

          if (moment(this.state.start_date) >= moment(this.state.end_date)) {
            this.setState({
              end_date: null,
              end_day: '',
            })
          }
        } else if (name == 'end_date') {
          this.setState({
            end_day: moment(this.state.end_date).format('dddd').toLowerCase(),
          })
        } else if (name == 'package_start_date') {
          if (moment(this.state.package_start_date) >= moment(this.state.package_end_date)) {
            this.setState({ package_end_date: null })
          }
        }
      }
    )
  }

  showErrorAlert = (title) => {
    Swal.fire({
      title: title,
      icon: 'error',
      type: 'error',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })
  }

  onSaveData = () => {
    const formData = new FormData()

    formData.append('name_en', this.state.name_en)
    formData.append('name_ar', this.state.name_ar)
    formData.append('desc_en', this.state.desc_en)
    formData.append('desc_ar', this.state.desc_ar)
    formData.append('ref_name', this.state.ref_name)

    // formData.append('is_special_package', this.state.is_special_package)
    formData.append('is_active', this.state.is_active)

    // formData.append('start_date', this.state.start_date || '')
    // formData.append('end_date', this.state.end_date || '')

    formData.append('package_start_date', this.state.package_start_date)
    formData.append('package_end_date', this.state.package_end_date)

    formData.append('start_day', this.state.start_day)
    formData.append('end_day', this.state.end_day)

    if (
      this.state.is_special_package &&
      this.state.start_date &&
      this.state.end_date &&
      moment(this.state.start_date) >= moment(this.state.end_date)
    ) {
      this.showErrorAlert('Invalid Dates')
      return
    }

    if (
      !this.state.package_end_date ||
      !this.state.package_start_date ||
      moment(this.state.package_start_date) >= moment(this.state.package_end_date)
    ) {
      this.showErrorAlert('Invalid Package Period Dates')
      return
    }

    if (this.state.img?.type) {
      formData.append('img', this.state.img, 'your_original_filename.jpeg')
    }

    this.setState({ isSaving: true })

    if (this.props.match.params.id) {
      formData.append('id', this.props.match.params.id)

      axios
        .put(Constant.getAPI() + '/chalet/update-chalet-global-package', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Updated !', `Package has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    } else {
      if (!this.state.img?.type) {
        this.showErrorAlert('Please add package image!')
        this.setState({ isSaving: false })
        return
      }
      axios
        .post(Constant.getAPI() + '/chalet/add-chalet-global-package', formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Added !', `Package has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
          }
        })
        .finally(() => {
          this.setState({ isSaving: false })
        })
    }
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getPackageDetails()
    }
  }

  getPackageDetails = async () => {
    console.log(this.props.match.params.id)
    await axios
      .get(Constant.getAPI() + `/chalet/get-chalet-global-packages/${this.props.match.params.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ ...res?.data?.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          this.showErrorAlert(err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message)
        }
      })
  }

  handleChangeImage = (e) => {
    this.setState({ img: e })

    // this.setState({ package_img: URL.createObjectURL(e) })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      Chalet Package
                      {this.props.match.params.id ? ' Edit' : ' Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/chalet-global-packages`}> Chalet Global Package List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Chalet Global Package {this.props.match.params.source_id ? 'Edit' : 'Add'}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Reference Name</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="ref_name"
                              id="ref_name"
                              placeholder={`Reference Name`}
                              onChange={this.handleChange}
                              value={this.state.ref_name}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      ></div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Package Name: English</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="name_en"
                              id="name_en"
                              placeholder={`Package Name: English`}
                              onChange={this.handleChange}
                              value={this.state.name_en}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Package Name: Arabic</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="name_ar"
                              id="name_ar"
                              placeholder={`Package Name: Arabic`}
                              onChange={this.handleChange}
                              value={this.state.name_ar}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Description: English</label>
                          <div className="col-sm-9">
                            <textarea
                              type="text"
                              className="form-control"
                              name="desc_en"
                              placeholder="Description: English"
                              onChange={this.handleChange}
                              value={this.state.desc_en}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Description: Arabic</label>
                          <div className="col-sm-9">
                            <textarea
                              type="text"
                              className="form-control"
                              name="desc_ar"
                              placeholder="Description: Arabic"
                              onChange={this.handleChange}
                              value={this.state.desc_ar}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      ></div>

                      <div className="col-md-12 mb-2">
                        <h6>Package Period</h6>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Start Date</label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              name="package_start_date"
                              id="package_start_date"
                              onChange={this.handleChange}
                              value={this.state.package_start_date || ''}
                              min={new Date().toISOString().split('T')[0]}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">End Date</label>
                          <div className="col-sm-9">
                            <input
                              type="date"
                              className="form-control"
                              name="package_end_date"
                              id="package_end_date"
                              onChange={this.handleChange}
                              value={this.state.package_end_date || ''}
                              min={new Date().toISOString().split('T')[0]}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      ></div>

                      {/* <div className="col-md-9">
                        <div className="form-group row">
                          <label className="col-sm-2 col-form-label">Is Special Package</label>
                          <div className="col-sm-10">
                            <Toggle
                              id="is_special_package"
                              name="is_special_package"
                              checked={this.state.is_special_package == true ? true : false}
                              onChange={() => {
                                this.setState({
                                  is_special_package: !this.state.is_special_package,
                                  start_day: '',
                                  end_day: '',
                                  start_date: null,
                                  end_date: null,
                                })
                              }}
                            />
                          </div>
                        </div>
                      </div> */}

                      {/* {this.state.is_special_package ? (
                        <>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Select From Date</label>
                              <div className="col-sm-9">
                                <input
                                  type="date"
                                  className="form-control"
                                  name="start_date"
                                  id="start_date"
                                  onChange={this.handleChange}
                                  value={this.state.start_date || ''}
                                  min={new Date().toISOString().split('T')[0]}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Select To Date</label>
                              <div className="col-sm-9">
                                <input
                                  type="date"
                                  className="form-control"
                                  name="end_date"
                                  id="end_date"
                                  onChange={this.handleChange}
                                  value={this.state.end_date || ''}
                                  min={new Date().toISOString().split('T')[0]}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Start Day</label>
                              <div className="col-sm-9">
                                <select
                                  disabled
                                  name="start_day"
                                  className="form-control"
                                  value={this.state.start_day}
                                  onChange={this.handleChange}
                                >
                                  <option value="">Select Option</option>
                                  <option value="sunday">Sunday</option>
                                  <option value="monday">Monday</option>
                                  <option value="tuesday">Tuesday</option>
                                  <option value="wednesday">Wednesday</option>
                                  <option value="thursday">Thursday</option>
                                  <option value="friday">Friday</option>
                                  <option value="saturday">Saturday</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">End Day</label>
                              <div className="col-sm-9">
                                <select
                                  disabled
                                  name="end_day"
                                  className="form-control"
                                  value={this.state.end_day}
                                  onChange={this.handleChange}
                                >
                                  <option value="">Select Option</option>
                                  <option value="sunday">Sunday</option>
                                  <option value="monday">Monday</option>
                                  <option value="tuesday">Tuesday</option>
                                  <option value="wednesday">Wednesday</option>
                                  <option value="thursday">Thursday</option>
                                  <option value="friday">Friday</option>
                                  <option value="saturday">Saturday</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <> */}
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Start Day</label>
                          <div className="col-sm-9">
                            <select
                              name="start_day"
                              className="form-control"
                              value={this.state.start_day}
                              onChange={this.handleChange}
                            >
                              <option value="">Select Option</option>
                              <option value="sunday">Sunday</option>
                              <option value="monday">Monday</option>
                              <option value="tuesday">Tuesday</option>
                              <option value="wednesday">Wednesday</option>
                              <option value="thursday">Thursday</option>
                              <option value="friday">Friday</option>
                              <option value="saturday">Saturday</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">End Day</label>
                          <div className="col-sm-9">
                            <select
                              name="end_day"
                              className="form-control"
                              value={this.state.end_day}
                              onChange={this.handleChange}
                            >
                              <option value="">Select Option</option>
                              <option value="sunday">Sunday</option>
                              <option value="monday">Monday</option>
                              <option value="tuesday">Tuesday</option>
                              <option value="wednesday">Wednesday</option>
                              <option value="thursday">Thursday</option>
                              <option value="friday">Friday</option>
                              <option value="saturday">Saturday</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* </>
                      )} */}

                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      ></div>

                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-3">Image</div>
                          <div className="col-sm-9">
                            <ImageCropper
                              ratio={1 / 1}
                              img={this.state.img || null}
                              onChange={(e) => {
                                this.handleChangeImage(e)
                              }}
                            ></ImageCropper>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Is Active</label>
                          <div className="col-sm-9">
                            <Toggle
                              id="is_active"
                              name="is_active"
                              checked={this.state.is_active == true ? true : false}
                              onChange={() => {
                                this.setState({
                                  is_active: !this.state.is_active,
                                })
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row float-right p-3">
                      <Button
                        disabled={this.state.isSaving}
                        color="primary"
                        onClick={this.onSaveData}
                        className="f-right ml-1"
                        startIcon={<i className="icofont icofont-save"></i>}
                        variant="contained"
                      >
                        {this.state.isSaving ? 'Saving...!' : 'Save'}
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        className="f-right ml-1"
                        onClick={() => window.history.back()}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PackageAddEdit
